var collapsible_list_component_default = {
  "ltr": "Yybr-",
  "rtl": "yV5VH",
  "iconContainer": "Wido3",
  "icon": "puQQf",
  "isExpanded": "nnaTt",
  "listDimensions": "_--FEv"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
